import { GridItem, GridItemProps, Skeleton, Text } from "@chakra-ui/react";
import React from "react";

interface GridItemLabelValueProps {
  label: string;
  value: string;
  labelItemProps?: GridItemProps;
  isLoading?: boolean;
}
export const GridItemLabelValue = ({
  value,
  label,
  labelItemProps,
  isLoading,
}: GridItemLabelValueProps) => {
  return (
    <>
      <GridItem {...labelItemProps}>
        <Text display="inline" textStyle="bodyRegularBold">
          {label}
        </Text>
      </GridItem>
      <GridItem>
        {isLoading ? (
          <Skeleton w={"100%"} height={"20px"} />
        ) : (
          <Text display="inline">{value}</Text>
        )}
      </GridItem>
    </>
  );
};
